let tmpId = 1;

export class WebForm {

    constructor(config) {
        this.pageActions = config.formPageActions;
        this.settings = config.formSettings;
        this.pages = config.pages = new WebFormPages(config.pages);
        this.finishPage = config.finishPage;
        this.finishPageCond = config.finishPageCond;
    }
}

export class WebFormPages {
    constructor(pages) {
        this.items = [];

        pages.forEach((item, index) => {
            pages[index] = new WebFormPage(item);
            this.items.push(pages[index]);
        });
    }

    getAllFormFields()
    {
        let result = [];

        this.items.forEach(item => {
            result.push(...item.getAllFormFields());
        });

        return result;
    }
}

export class WebFormCollection {
    constructor() {
        this.id = tmpId++;
        this.items = [];

        this._parent = null;
    }

    get parent()
    {
        return this._parent;
    }

    set parent(value)
    {
        this._parent = value;
    }

    get root()
    {
        let result = this._parent;

        if (!result)
            return result;

        while (result.parent)
        {
            result = result.parent;
        }

        return result;
    }

    getItemById(id) {
        let result = null;

        this.items.every(item => {
            if (item.id === id)
                result = item;

            return result === null;
        });

        return result;
    }
}

export class WebFormLayout extends WebFormCollection {
    constructor(config, rows) {
        super();

        this.config = config;

        rows.forEach((item, index) => {
            rows[index] = new WebFormPageRow(item);
            rows[index].parent = this;
            this.items.push(rows[index]);
        });
    }

    _getItemsRecursive(items)
    {
        this.items.forEach(row => {
            row.items.forEach(item => {

                if (item.childLayout)
                {
                    item.childLayout._getItemsRecursive(items);
                }

                items.push(item);

            });
        });
    }

    getAllFormFields()
    {
        let result = [];

        this._getItemsRecursive(result);

        return result;
    }
}

export class WebFormPage extends WebFormLayout {
    constructor(page) {
        super(page.config, page.rows);
    }
}

export class WebFormPageRow extends WebFormCollection {
    constructor(row) {
        super();

        row.items.forEach((item, index) => {
            row.items[index] = new WebFormFieldItem(item);
            row.items[index].parent = this;
            this.items.push(row.items[index]);
        });
    }
}

export class WebFormFieldItem {
    constructor(item) {
        this.id = tmpId++;
        this.size = item.size;
        this.config = item.config;
        this.fieldId = item.fieldId;
        this.component = null;
        this.childLayout = null;
        this.errorMessage = false;
        this._parent = null;

        if (item.config.layout)
        {
            this.childLayout = new WebFormLayout(this.config.layout.config, this.config.layout.rows);
            this.childLayout.parent = this;
        }
    }

    get parent()
    {
        return this._parent;
    }

    set parent(value)
    {
        this._parent = value;
    }

    get root()
    {
        let result = this._parent;

        if (!result)
            return result;

        while (result.parent)
        {
            result = result.parent;
        }

        return result;
    }

    get rootPage()
    {
        let result = this._parent;

        if (!result)
            return result;

        while (!(result instanceof WebFormPage) && result.parent)
        {
            result = result.parent;
        }

        return result;
    }

}